




























	import { Component,  } from "../../../Infrastructure/CorBase/CoreBase";
	import EnumListBase from "./EnumListBase";

    @Component
    export default class EnumList extends EnumListBase {

		created() {
			
            super.initializeRights('COR_EnuType_Create', 'COR_EnuType_Delete', 'COR_EnuType_Read', 'COR_EnuType_Update');
         //   this.fetchAvailableEnumsList();
            super.created();
            super.setDetailName('EnumDetail');
        };

        sortEnums() {
            return this.sortEnumsBase();
        }

        showAllertToDeleteClick(itemsSelected: any) {
            super.showAlertBeforeActionClickBase(itemsSelected, this.$t('user.messageQuestionMain').toString(), true);
        }

        // VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
        loadFilters(value: any) { super.loadFilters(value); }
        createNewClick(elementId: any) {
				this.$router.push({ name: this.detailName, query: {idGroup: this.getSelectedGroup(), identifier: this.getSelectedGroupIdentif() }});
		}
        detailClick(elementId: any) { super.detailClick(elementId); }



	};
